/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AvatarUpdated
 */
export interface AvatarUpdated {
    /**
     *
     * @type {boolean}
     * @memberof AvatarUpdated
     */
    readonly success: boolean;
    /**
     *
     * @type {string}
     * @memberof AvatarUpdated
     */
    readonly message: string;
    /**
     *
     * @type {string}
     * @memberof AvatarUpdated
     */
    readonly avatarUrl: string | null;
}

/**
 * Check if a given object implements the AvatarUpdated interface.
 */
export function instanceOfAvatarUpdated(value: object): value is AvatarUpdated {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function AvatarUpdatedFromJSON(json: any): AvatarUpdated {
    return AvatarUpdatedFromJSONTyped(json, false);
}

export function AvatarUpdatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvatarUpdated {
    if (json == null) {
        return json;
    }
    return {

        'success': json['success'],
        'message': json['message'],
        'avatarUrl': json['avatar_url'],
    };
}

  export function AvatarUpdatedToJSON(json: any): AvatarUpdated {
      return AvatarUpdatedToJSONTyped(json, false);
  }

  export function AvatarUpdatedToJSONTyped(value?: Omit<AvatarUpdated, 'success'|'message'|'avatar_url'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
